export default __webpack_public_path__ + "static/media/feather _orange- chevron-right.40a785c7.svg";